<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 25 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M2.34375 3.125H3.78717C4.31809 3.125 4.78268 3.48193 4.91948 3.99492L5.31864 5.49176M7.8125 14.8438C6.08661 14.8438 4.6875 16.2429 4.6875 17.9688H21.0938M7.8125 14.8438H19.4982C20.666 12.4473 21.6851 9.96495 22.5435 7.40886C17.5834 6.14214 12.386 5.46875 7.03125 5.46875C6.45855 5.46875 5.88765 5.47646 5.31864 5.49176M7.8125 14.8438L5.31864 5.49176M6.25 21.0938C6.25 21.5252 5.90022 21.875 5.46875 21.875C5.03728 21.875 4.6875 21.5252 4.6875 21.0938C4.6875 20.6623 5.03728 20.3125 5.46875 20.3125C5.90022 20.3125 6.25 20.6623 6.25 21.0938ZM19.5312 21.0938C19.5312 21.5252 19.1815 21.875 18.75 21.875C18.3185 21.875 17.9688 21.5252 17.9688 21.0938C17.9688 20.6623 18.3185 20.3125 18.75 20.3125C19.1815 20.3125 19.5312 20.6623 19.5312 21.0938Z"
				:stroke="color"
				stroke-width="1.5625"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgCart',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
